import React from 'react';
import { Phone, MapPin, Mail } from 'lucide-react';
import SocialLinks from './SocialLinks';

const Footer = ({ currentLang, translations }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div className="md:col-span-2 space-y-4">
            <div className="flex items-center space-x-3 rtl:space-x-reverse mb-4">
              <div className="w-10 h-10 bg-gradient-to-r from-blue-600 to-blue-700 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">X</span>
              </div>
              <div>
                <h3 className="text-2xl font-bold">XKey24</h3>
                <p className="text-gray-400 text-sm">{translations[currentLang].tagline}</p>
              </div>
            </div>
            
            <p className="text-gray-300 leading-relaxed max-w-md">
              {translations[currentLang].footer.description}
            </p>
            
            <div className="flex flex-col sm:flex-row items-start sm:items-center space-y-4 sm:space-y-0 sm:space-x-4 rtl:space-x-reverse pt-4">
              <a 
                href="tel:+972553002025"
                className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-lg flex items-center space-x-2 rtl:space-x-reverse transition-colors"
              >
                <Phone className="w-4 h-4" />
                <span className="font-semibold">+972-55-300-2025</span>
              </a>
              
              <div className="flex flex-col space-y-2">
                <span className="text-gray-400 text-sm">Follow us:</span>
                <SocialLinks size="w-5 h-5" />
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-white mb-4">
              {translations[currentLang].footer.quickLinks}
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="#services" className="text-gray-300 hover:text-white transition-colors">
                  {translations[currentLang].nav.services}
                </a>
              </li>
              <li>
                <a href="#about" className="text-gray-300 hover:text-white transition-colors">
                  {translations[currentLang].nav.about}
                </a>
              </li>
              <li>
                <a href="#ourwork" className="text-gray-300 hover:text-white transition-colors">
                  {translations[currentLang].nav.ourWork}
                </a>
              </li>
              <li>
                <a href="#areas" className="text-gray-300 hover:text-white transition-colors">
                  {translations[currentLang].nav.areas}
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-300 hover:text-white transition-colors">
                  {translations[currentLang].nav.contact}
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-white mb-4">
              {translations[currentLang].footer.contact}
            </h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-blue-400 mt-1 flex-shrink-0" />
                <div>
                  <a href="tel:+972553002025" className="text-gray-300 hover:text-white transition-colors">
                    +972-55-300-2025
                  </a>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-blue-400 mt-1 flex-shrink-0" />
                <div>
                  <span className="text-gray-300">
                    Zunz 30, {translations[currentLang].hero.telAviv}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Services List */}
        <div className="border-t border-gray-800 pt-8 mb-8">
          <h4 className="text-lg font-semibold text-white mb-4">
            {translations[currentLang].footer.services}
          </h4>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="text-gray-300 text-sm">
              {translations[currentLang].services.items.carKeys.title}
            </div>
            <div className="text-gray-300 text-sm">
              {translations[currentLang].services.items.ignition.title}
            </div>
            <div className="text-gray-300 text-sm">
              {translations[currentLang].services.items.lockout.title}
            </div>
            <div className="text-gray-300 text-sm">
              {translations[currentLang].services.items.transponder.title}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row items-center justify-between">
          <div className="text-gray-400 text-sm mb-4 md:mb-0">
            © {currentYear} XKey24. {translations[currentLang].footer.rights}.
          </div>
          
          <div className="text-gray-400 text-sm">
            {translations[currentLang].services.emergency.title} - 24/7
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;